
  import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator'
  import getFormData from 'get-form-data'
  import { State, Getter, Action, Mutation } from '../store-helper'
  import AnswerItem from '../../../common/AnswerItem'
  import { IQuestion, IAnswerItem } from '../../../types'
  import { IAnswer } from '../types'

  @Component({
  })
  export default class QuestionContentComponent extends Vue {
    @State answers
    @Action submit
    @Action updateAnswer

    @Prop()
    currentQuestion: IQuestion<IAnswerItem>
    @Prop()
    currentQuestionIndex: number

    public get currentAnswers(): IAnswer[] {
      return this.answers.filter((answer) => answer.q_id == this.currentQuestion.id)
    }

    public fillValue() {
      // this is async process so we should check for sure
      const answerForm = this.$refs["answerForm-"+this.currentQuestion.id] as any;
      if (!this.currentAnswers || this.currentAnswers.length == 0 || this.currentAnswers[0].q_id != this.currentQuestion.id) {
        const textareas: any[] = answerForm.getElementsByTagName("textarea");
        for (let index=0; index < textareas.length; index++) {
        const element = textareas[index];
        switch (this.currentQuestion.fieldType) {
          case "textarea":
            const CKEDITOR = (<any>window).CKEDITOR;
            if (CKEDITOR) {
              CKEDITOR.replace(element.id, {})
            }
            break;
        }
      }
        return;
      }
      const inputs: any[] = answerForm.getElementsByTagName("input");
      for (let index=0; index < inputs.length; index++) {
        const element = inputs[index];
        switch (this.currentQuestion.fieldType) {
          case "checkbox":
          case "multi_checkbox":
          case "radio":
            element.checked = this.currentAnswers.findIndex((answer) => answer.body == element.value) >= 0;
            break;
          case "textfield":
            element.value = this.currentAnswers[index].body;
            break;
        }
      }

      const selects: any[] = answerForm.getElementsByTagName("select");
      for (let index=0; index < selects.length; index++) {
        const element = selects[index];
        switch (this.currentQuestion.fieldType) {
          case "select":
            element.value = this.currentAnswers[index].body;
            break;
        }
      }

      const textareas: any[] = answerForm.getElementsByTagName("textarea");
      for (let index=0; index < textareas.length; index++) {
        const element = textareas[index];
        switch (this.currentQuestion.fieldType) {
          case "textarea":
            const CKEDITOR = (<any>window).CKEDITOR;
            element.value = this.currentAnswers[index].body;
            if (CKEDITOR) {
              CKEDITOR.replace(element.id, {})
            }
            break;
        }
      }
    }

    public answerQuestion(): Promise<any> {
      const textareas: any[] = (<any>this.$refs["answerForm-"+this.currentQuestion.id]).getElementsByTagName("textarea");
      for (let index=0; index < textareas.length; index++) {
        const element = textareas[index]
        const CKEDITOR = (<any>window).CKEDITOR
        element.value = CKEDITOR.instances[element.id].getData()
      }
      const answerData = getFormData(this.$refs["answerForm-"+this.currentQuestion.id])
      return this.updateAnswer({ answer: answerData, questionId: this.currentQuestion.id })
    }

    public submitExam() {
      this.submit()
    }

    public get currentQuestionContent(): string {
      return this.currentQuestion ? this.currentQuestion.body : "";
    }
  }
